import { render } from "./ExtensionApplications.vue?vue&type=template&id=f0ff7c38&scoped=true&ts=true"
import script from "./ExtensionApplications.vue?vue&type=script&lang=ts"
export * from "./ExtensionApplications.vue?vue&type=script&lang=ts"

import "./ExtensionApplications.vue?vue&type=style&index=0&id=f0ff7c38&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0ff7c38"]])

export default __exports__